import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExportIcon from 'components/Icons/Export';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

class ExportButton extends PureComponent {
  static propTypes = {
    formats: PropTypes.object,
    classes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      openExports: false,
    };

    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onExportJSON = this.onExportJSON.bind(this);
    this.onExportCSV = this.onExportCSV.bind(this);
  }

  onExportJSON(event, value) {
    window.location = this.props.formats.json;
  }

  onExportCSV(event, value) {
    window.location = this.props.formats.csv;
  }

  onOpen(event) {
    event.preventDefault();

    this.setState({
      openExports: true,
      anchorEl: event.currentTarget,
    });
  }

  onClose() {
    this.setState({
      openExports: false,
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Button
          className={classes.button}
          onClick={this.onOpen}
          startIcon={<ExportIcon size="small" className={classes.exportIcon} />}
        >
          Export
        </Button>
        <Menu open={this.state.openExports} anchorEl={this.state.anchorEl} onClose={this.onClose}>
          <MenuItem onClick={this.onExportJSON}> JSON </MenuItem>
          <MenuItem onClick={this.onExportCSV}> CSV </MenuItem>
        </Menu>
      </div>
    );
  }
}

const styles = theme => {
  return {
    root: {},
    button: {},
    exportIcon: {
      color: theme.palette.secondary.main,
    },
  };
};

export default withStyles(styles)(ExportButton);
